export function type(a) {
  return Object.prototype.toString.call(a).slice(8, -1)
}

export function filterUndefined(data) {
  if (type(data) !== 'Object') {
    return data
  }
  data = Object.assign({}, data)
  Object.keys(data).forEach(key => {
    if (data[key] === undefined) {
      delete data[key]
    } else if (data[key] === null) {
      data[key] = ''
    }
  })
  return data
}